// #575: Gesendete Entwürfe sollen nicht im Ordner Entwürfe bleiben. Der eigene Entwurf des
// Schreibfensters wird beim Senden gelöscht (#567). Liegen blieb ein ÄLTERER Entwurf derselben
// Antwort: Fenster geschlossen (Entwurf gesichert), später über „Antworten“ neu angesetzt und
// gesendet. Solche Entwürfe erkennt man an gleichem Betreff und gleichen Empfängern.
import { supabase } from '../supabase/client';

const norm = (s: string | null | undefined) => (s || '').trim().replace(/\s+/g, ' ').toLowerCase();
const adressen = (l: string[] | null | undefined) => [...new Set((l || []).map((a) => a.trim().toLowerCase()).filter(Boolean))].sort().join(',');

/** Ist dieser Entwurf durch die gerade gesendete Mail überholt? (gleicher Betreff + gleiche An-Empfänger) */
export function istUeberholterEntwurf(
  entwurf: { betreff: string | null; an: string[] | null },
  gesendet: { betreff: string; an: string[] },
): boolean {
  if (!norm(gesendet.betreff) || adressen(gesendet.an) === '') return false;
  return norm(entwurf.betreff) === norm(gesendet.betreff) && adressen(entwurf.an) === adressen(gesendet.an);
}

/** Überholte eigene Entwürfe im Postfach löschen. Fehler nur in die Konsole – der Versand ist ja erfolgt. */
export async function raeumeUeberholteEntwuerfeAuf(
  kontoId: string, userId: string | null, gesendet: { betreff: string; an: string[] }, ausser: string | null,
): Promise<number> {
  if (!userId) return 0;
  const { data, error } = await supabase.from('emails').select('id, betreff, an')
    .eq('ordner', 'DRAFT').eq('konto_id', kontoId).eq('user_id', userId).is('geloescht_am', null).limit(500);
  if (error) { console.warn('Entwürfe aufräumen: Laden fehlgeschlagen', error.message); return 0; }
  const ids = (data || [])
    .filter((d: { id: string; betreff: string | null; an: string[] | null }) => d.id !== ausser && istUeberholterEntwurf(d, gesendet))
    .map((d: { id: string }) => d.id);
  if (ids.length === 0) return 0;
  const { data: weg, error: e2 } = await supabase.from('emails').delete().in('id', ids).select('id');
  if (e2) { console.warn('Entwürfe aufräumen fehlgeschlagen', e2.message); return 0; }
  return weg?.length ?? 0;
}
